import { createSlice, current } from "@reduxjs/toolkit";
import getBlobDuration from 'get-blob-duration';

export const RecordSlice = createSlice({
  name: 'record',
  initialState: { recordedVideo: [], recordedVideoData: [], editVideo: [], thumbnail: null, intro: null, outro: null, title: "", tag: [] },
  reducers: {
    saveVideo: (state, action) => {
      const { payload } = action;
      const currentFiles = current(state.recordedVideo);
      const newFiles = [...currentFiles, payload];
      state.recordedVideo = newFiles;
    },

    saveVideoData: (state, action) => {
      const { payload } = action;
      state.recordedVideoData = payload;
    },

    addTranscript: (state, action) => {
      const { payload } = action;
      const currentFiles = current(state.recordedVideoData);
      const fileHolder = [];

      for (let i = 0; i < 10; i++) {
        currentFiles.forEach(item => {
          if((item.id - 1) === i) {
            let newObject = { ...item, transcript: payload[i] }
            fileHolder.push(newObject);
          }
        })
      }

      state.recordedVideoData = fileHolder;
    },

    addThumbnail: (state, action) => {
      const { payload } = action;
      state.thumbnail = payload
    },

    addIntro: (state, action) => {
      const { payload } = action;
      state.intro = payload;
    },

    addOutro: (state, action) => {
      const { payload } = action;
      state.outro = payload;
    },

    setTitle: (state, action) => {
      const { payload } = action;
      state.title = payload;
    },

    setTag: (state, action) => {
      const { payload } = action;

      if(payload.type === "add") {
        state.tag[payload.pos] = payload.value
      }else if(payload.type === "del") {
        let tmpt = state.tag.filter((t, idx) => idx !== payload.pos)
        state.tag = tmpt
      }
    },

    editVideo: (state, action) => {
      const { payload } = action;

      state.editVideo = payload;
    },

    saveEditedVideo: (state, { payload }) => {
      const prev = current(state.editVideo);
      
      const newVideoObject = {
        ...prev,
        file: payload,
        duration: getBlobDuration(payload)
      }

      state.editVideo = newVideoObject;
    },

    save: (state, { payload }) => {
      const prev = current(state.recordedVideoData);
      const deleteCurrent = prev.filter(item => item.id !== payload.id);
      const newVideos = [
        payload,
        ...deleteCurrent
      ]
      const sortVideos = newVideos.sort((a, b) => a.id - b.id);

      state.recordedVideoData = sortVideos;
    },

    deleteVideo: (state, action) => {
      const { payload } = action;

      const newObject = current(state.recordedVideoData).filter(item => item.id !== payload);
      const updateRecordedVideo = newObject.map(item => item.file);
      
      state.finalVideo = newObject
      state.recordedVideoData = newObject
      state.recordedVideo = updateRecordedVideo
    },

    reset: (state, action) => {
      return {
        ...state, recordedVideo: [], recordedVideoData: [], editVideo: [], thumbnail: null, intro: null, outro: null, title: "", tag: []
      }
    }
  }
});

export default RecordSlice.reducer;